/**
 * Application constants
 */

export const UNCATEGORIZED_ID = 22;
